<template>
  <div class="blog-card-list">
    <div v-if="posts.length === 0" class="text-center py-5">
      <i class="fa fa-pencil-square-o fa-3x mb-3" style="color: #adb5bd;"></i>
      <p class="text-muted">No blog posts yet. Create your first post!</p>
    </div>

    <div class="row">
      <div
        v-for="post in posts"
        :key="post._id"
        class="col-lg-4 col-md-6 mb-4"
      >
        <card shadow class="blog-card h-100" :class="{ 'border-warning': !post.published }">
          <!-- Cover Image -->
          <div v-if="post.coverImage" class="blog-card-image mb-3">
            <img :src="post.coverImage" class="img-fluid rounded" :alt="post.title" />
          </div>
          <div v-else class="blog-card-placeholder mb-3">
            <i class="fa fa-newspaper-o"></i>
          </div>

          <!-- Tags -->
          <div class="mb-2" v-if="post.tags && post.tags.length">
            <span
              v-for="(tag, idx) in post.tags.slice(0, 3)"
              :key="idx"
              class="badge badge-pill badge-primary mr-1"
              style="font-size: 0.7rem;"
            >
              {{ tag }}
            </span>
          </div>

          <!-- Title -->
          <h5 class="blog-card-title mb-2">
            <router-link :to="'/blog/' + post._id" class="text-dark">
              {{ post.title }}
            </router-link>
          </h5>

          <!-- Meta -->
          <div class="blog-card-meta text-muted mb-2" style="font-size: 0.8rem;">
            <span v-if="post.author">
              <i class="fa fa-user mr-1"></i>{{ post.author }}
            </span>
            <span v-if="post.date" class="ml-2">
              <i class="fa fa-calendar mr-1"></i>{{ formatDate(post.date) }}
            </span>
            <span v-if="!post.published" class="ml-2 text-warning">
              <i class="fa fa-eye-slash mr-1"></i>Draft
            </span>
          </div>

          <!-- Excerpt -->
          <p class="blog-card-excerpt text-muted" style="font-size: 0.9rem;">
            {{ truncate(post.excerpt || stripHtml(post.content), 120) }}
          </p>

          <!-- Actions -->
          <div class="blog-card-actions mt-auto pt-3 border-top">
            <router-link :to="'/blog/' + post._id" class="btn btn-sm btn-primary">
              <i class="fa fa-book mr-1"></i>Read
            </router-link>
            <button
              v-if="showActions"
              class="btn btn-sm btn-outline-default ml-1"
              @click="$emit('edit', post)"
            >
              <i class="fa fa-pencil"></i>
            </button>
            <button
              v-if="showActions"
              class="btn btn-sm btn-outline-info ml-1"
              @click="$emit('toggle-publish', post._id)"
              :title="post.published ? 'Unpublish' : 'Publish'"
            >
              <i :class="post.published ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
            </button>
            <button
              v-if="showActions"
              class="btn btn-sm btn-outline-danger ml-1"
              @click="confirmDelete(post._id)"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlogList',
  props: {
    posts: {
      type: Array,
      default: () => []
    },
    showActions: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return ''
      const options = { year: 'numeric', month: 'short', day: 'numeric' }
      return new Date(dateStr).toLocaleDateString('en-US', options)
    },
    truncate(text, length) {
      if (!text) return ''
      return text.length > length ? text.substring(0, length) + '...' : text
    },
    stripHtml(html) {
      if (!html) return ''
      const tmp = document.createElement('div')
      tmp.innerHTML = html
      return tmp.textContent || tmp.innerText || ''
    },
    confirmDelete(postId) {
      if (confirm('Are you sure you want to delete this post?')) {
        this.$emit('delete', postId)
      }
    }
  }
}
</script>

<style scoped>
.blog-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.blog-card:hover {
  transform: translateY(-4px);
}

.blog-card-image img {
  width: 100%;
  height: 180px;
  object-fit: cover;
}

.blog-card-placeholder {
  width: 100%;
  height: 120px;
  background: linear-gradient(135deg, #5e72e4, #825ee4);
  border-radius: 0.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 2rem;
}

.blog-card-title a {
  text-decoration: none;
}

.blog-card-title a:hover {
  color: #5e72e4 !important;
}

.blog-card-excerpt {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.blog-card-actions {
  display: flex;
  align-items: center;
}
</style>
